import session from "../../../services/session";
import swal from "sweetalert2";
import AdminApi from "../../../services/api";

const AdminApiService = new AdminApi()
export default {
    data() {
        return {
            model: {
                days: ['MONDAY'],
                maxTrainings: 0,
                startAt: '',
                trainingType: ""
            },
            types: [],
            days: [
                {
                    key: "MONDAY",
                    value: "Ponedeljak",
                },
                {
                    key: "TUESDAY",
                    value: "Utorak",
                },
                {
                    key: "WEDNESDAY",
                    value: "Sreda",
                },
                {
                    key: "THURSDAY",
                    value: "Četvrtak",
                },
                {
                    key: "FRIDAY",
                    value: "Petak",
                },
                {
                    key: "SATURDAY",
                    value: "Subota",
                },
                {
                    key: "SUNDAY",
                    value: "Nedelja",
                },
            ]
        }
    },
    methods: {
        addTerm: addTerm,
        getTrainingTypes: getTrainingTypes,
        onChangeCheckBoxDay: onChangeCheckBoxDay,
        isChecked: isChecked
    },
    beforeMount() {
        if (session.getRole() !== 'ADMIN' && session.getRole() !== 'DISPATCHER') {
            this.$router.push('/home');
            return;
        }
        this.getTrainingTypes()
    }
}

function addTerm() {
    let _self = this;
    if(_self.model.days.length === 0){
        swal('Greška', 'Morate izabrati bar jedan dan.', 'error')
        return
    }
    AdminApiService.addTerm(_self.model)
        .then((response) => {
            swal('Uspešno', 'Uspešno dodat termin', 'success')
            this.$router.push('/pre-terms');
        })
        .catch(error => {
            swal('Greška', error.data.localized_error_message, 'error')
        })

}

function getTrainingTypes() {
    let _self = this;
    AdminApiService.getTrainingTypes()
        .then((response) => {
            _self.types = response.data
            for(var temp in response.data) {
                _self.model.trainingType = temp
                return
            }
        })
        .catch(error => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function onChangeCheckBoxDay(key, id) {
    let isChecked = document.getElementById(key).checked
    if(isChecked){
        if(this.model.days.indexOf(id) < 0){
            this.model.days.push(id);
        }
    }else{
        const index = this.model.days.indexOf(id);
        if (index > -1) {
            this.model.days.splice(index, 1);
        }
    }
}

function isChecked(key) {
    return this.model.days.includes(key);
}


// WEBPACK FOOTER //
// ./src/components/Term/Add/AddTerm.js